import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/layer/view/layer.view.query.gql"
import type {
  LayerViewQuery,
  LayerViewQueryVariables,
} from "@/v2-backoffice-client/layer/view/__types__/layer.view.query"

type Options = QueryHookOptions<LayerViewQuery, LayerViewQueryVariables>

export function useLayerViewQuery(options?: Options) {
  return useQuery<LayerViewQuery, LayerViewQueryVariables>(query, options)
}
